export default function UpdateFrequencyConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  vmDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleUpdateFrequencyConfirm = _handleUpdateFrequencyConfirm;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleUpdateFrequencyConfirm($event) {
    loaderService.showViewLoader = true;
    return vmDataService.updateProductAlertFrequency(vm.product.productId)
      .then(() => {
        alerts.success(`The alert frequency was successfully updated.`);
        if (vm.updateCallBack) {
          vm.updateCallBack($event);
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while update the frequency.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmResetFrequencyDialog);
  }
}

UpdateFrequencyConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'vmDataService',
  'loaderService',
  'ssDialogService'
];
